<template>
    <v-container>
        <v-layout row wrap>

            <v-col cols="3">
                <v-btn v-on:click="chooseHotel" 
                       v-show="!shouldShowPicker">{{ buttonLabel }}</v-btn>
                <v-btn v-on:click="clearHotel" 
                       v-show="selectedHotel">Clear</v-btn>
			</v-col>

            <v-col cols="10" v-if="shouldShowPicker">
                <v-container>
                    <v-layout row wrap>
 
                        <v-col cols="10">
                            <v-text-field
                                v-model="hotelViewName" 
                                v-on:keyup="updateHotelName()"
                             ></v-text-field>

                             <div class="selectable-hotels-results" v-if="hotelOptions.length && shouldShowHotels">
                                 <ul class="selectable-hotels-list">
                                     <li v-for="hotel in hotelOptions" v-on:click="selectHotel(hotel.hotel_key)">({{ hotel.hotel_code }}) {{ hotel.hotel_name }}</li>
                                 </ul>
                             </div>
                         </v-col>
                   </v-layout>
               </v-container>
           </v-col>

        </v-layout>
    </v-container>
</template>

<script>
    /**
     * Allows the selection of a hotel ID by choosing its name or code from
     * a selection downloaded from the API on creation
     *
     * @todo refactor, make more efficient
     */
    export default {
        name: 'ies-hotel-picker',
        props: ['configuration'],
        data() {
            return {
				showValidationGuide: false,

				errorMessages: [],

                /** string view model */
                hotelViewName: '',

                /** array of hotel options presented to the user */
                hotelOptions: [],

                /** data model of all supported hotels */
                hotels: [],

                /** view model to determine whether the hotel  picker should display */
                shouldShowPicker: true,

                shouldShowHotels: false,

                /** The hotel chosen by the user */
                viewValue: 0,

                selectedHotel: null,

                /** For where the component is used in event mode to talk to other components */
                config: {'shouldEmitOnSelect': false, 'selectEventName': ''}
            }
        },
        created:function() {
            console.log("****** HOTEL *******", this);

            // Load the hotels list from the server
            this.getHotels();

            if (this.configuration){
                var config = JSON.parse(this.configuration);
                console.log(config);
                if (config.shouldEmitOnSelect && config.selectEventName){
                    this.config.shouldEmitOnSelect = config.shouldEmitOnSelect;
                    this.config.selectEventName = config.selectEventName;
                }
            }
        },

        methods: {

            getHotels:function(){
                var self = this;
                axios.get('/api/hotelsWithRooms')
                .then(function(response){
                    this.hotels = response.data;
                }.bind(this));
            },

            updateHotelName: function(){
                if (this.hotelTypeTimer){
                    clearTimeout(this.hotelTypeTimer);
                }
                this.hotelTypeTimer = setTimeout(this.refineHotelOptions, 333);
           },


            refineHotelOptions: function(){
                var self = this;
 
                var hotelOptions = [];
                this.hotels.forEach(function(hotel){
                    if (hotel.hotel_code.toLowerCase().includes(self.hotelViewName.toLowerCase()) || hotel.hotel_name.toLowerCase().includes(self.hotelViewName.toLowerCase())){
                        hotelOptions.push(hotel);
                    }
                });
                this.hotelOptions = hotelOptions;

                // If there is only one hotel left in the list of options then we select it
                if (this.hotelOptions.length === 1){
                    this.selectedHotel = this.hotelOptions[0];
                }
                this.shouldShowHotels = true;
            },

            selectHotel: function(hotelKey){
                var self = this;
                this.hotels.forEach(function(hotel){
                    if (hotel.hotel_key === hotelKey){
                        self.selectedHotel = hotel;
                        self.hotelViewName = hotel.hotel_name;
                    }
                });
                this.shouldShowHotels = false;

                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {hotelKey: hotelKey});
                }
            },

            chooseHotel: function(){
                this.shouldShowPicker = true;
            },

            clearHotel: function(){
                this.selectedHotel = null;
                this.hotelViewName = '';

                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {hotelKey: null});
                }
            },

            done: function(){
                this.shouldShowPicker = false;
            },

        },
        watch: {
            viewValue: function (newValue) {
            }
        },
        computed: {
            buttonLabel: function(){
                return this.selectedHotel ? "(" + this.selectedHotel.hotel_code + ") " + this.selectedHotel.hotel_name : "Choose";
            }
        }

    }
</script>

<style>
.selectable-hotels-results{
    background-color: white;
    border: solid 1px #f5f5f5;
    width: auto;
    min-width: 20rem;
    max-height: 10rem;
    overflow-y: auto;
    position: absolute;
    z-index: 1;
}

.selectable-hotels-list {
  list-style-type: none;
}

.selectable-hotels-list li {
    cursor: pointer;
    padding: 3px;
}

.selectable-hotels-list li:hover {
    background-color: #f5f5f5;
}
</style>
